<div class="sidebar__brand">
  <a
    class="brand"
    routerLink="/dashboard"
    aria-label="KeyStoreMan, ir al dashboard"
    (click)="navigated.emit()">
    <span class="brand__mark" aria-hidden="true"><i class="bi bi-shield-lock-fill"></i></span>
    @if (!isRail()) {
      <span class="brand__text">
        <span class="brand__name">KeyStoreMan</span>
        <span class="brand__tag">Consola</span>
      </span>
    }
  </a>

  @if (isOverlay()) {
    <button
      type="button"
      class="ks-icon-btn sidebar__close"
      data-autofocus
      aria-label="Cerrar el menú de navegación"
      (click)="closeRequest.emit()">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  }
</div>

<div class="sidebar__scroll">
  <app-side-menu [rail]="isRail()" (navigated)="navigated.emit()" />
</div>

@if (!isOverlay()) {
  <div class="sidebar__foot">
    <button
      type="button"
      class="sidebar__rail-btn"
      [attr.aria-label]="railLabel()"
      [attr.title]="railLabel()"
      [attr.aria-pressed]="isRail()"
      (click)="railToggle.emit()">
      <i
        class="bi"
        [class.bi-chevron-double-left]="!isRail()"
        [class.bi-chevron-double-right]="isRail()"
        aria-hidden="true"></i>
      @if (!isRail()) {
        <span>Colapsar</span>
      }
    </button>
  </div>
}
